/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AgentFeedbackRequestDTO { 
    traceRunId: string;
    score: number;
    reason?: string;
    failureMode?: AgentFeedbackRequestDTO.FailureModeEnum;
    dashboardLiteralId?: string;
}
export namespace AgentFeedbackRequestDTO {
    export type FailureModeEnum = 'wrong_value' | 'missing_metric' | 'vague_narrative' | 'wrong_period' | 'other';
    export const FailureModeEnum = {
        WrongValue: 'wrong_value' as FailureModeEnum,
        MissingMetric: 'missing_metric' as FailureModeEnum,
        VagueNarrative: 'vague_narrative' as FailureModeEnum,
        WrongPeriod: 'wrong_period' as FailureModeEnum,
        Other: 'other' as FailureModeEnum
    };
}


